import React from "react";
import Navbar from './navBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/md-dark-indigo/theme.css";
import "primereact/resources/primereact.min.css"
import 'primeicons/primeicons.css';
import 'react-slideshow-image/dist/styles.css'
import { useTranslation } from "react-i18next";
import FooterComponent from "./footer";
import "../style/table.css"
import TableFeldspat from "./feldspatTable";
import { Menu } from "primereact/menu";
import FeldspatMenu from "./feldspatMenu";
import "../style/commonMobile.css";
const Feldspat = (props) => {
    const { t, i18n } = useTranslation();
    return (
        <PrimeReactProvider>
            <Navbar />
            <div className="feldspatContainer">
                <div style={{ display: "block" }}>
                    <FeldspatMenu />
                </div>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center" }}>
                    <TableFeldspat baslik="TEKNOMADEN FELDSPAR (-10MM) FK7402 TDS" plantAddress="Yeşilköy/Kavaklıdere/Muğla" kod="FK7402" density="-" bulkDensity="-" hardnessMohs="-" humidity="3" oilAbsorb="" na2o="6.80" k2o="0.49" cao="0.32" fe2o3="0.40" tio2="0.15" al2o3="13.90" mgo="0.30" p2o5="0.00" sio2="77.29" kk="0.35" l="71,36" a="1,50" b="14,36" albit="57.5" ortoklas="2.9" anortit="1.6" kaolinit="4.1" kuvars="33.9" />
                </div>
            </div>
            <FooterComponent />
        </PrimeReactProvider>
    );
}
export default Feldspat;